<template>
  <el-table
    empty-text="無資料"
    :data="table"
  >
    <el-table-column label="名稱">
      <template slot-scope="scope">
        <span class="row__icon">
          <font-awesome-icon :icon="['fa', 'file-alt']" size="lg" />
        </span>
        <span>
          {{ scope.row.displayName }}
        </span>
      </template>
    </el-table-column>

    <el-table-column label="下載" width="120">
      <template slot-scope="scope">
        <el-button
          size="mini"
          type="primary"
          round
          plain
          @click="beforeDownload(scope.row.id)"
        >
          <i class="el-icon-download"></i>
          下載
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  methods: {
    ...mapActions({
      downloadResource: 'download/downloadResource',
      notify: 'notification/notify',
    }),
    ...mapMutations({
      setTable: 'download/setTable'
    }),
    async beforeDownload (id) {
      try {
        let response = await this.downloadResource({ id: id })
        let url = response.data.url
        let newWindow = window.open('', '_blank')

        if (newWindow === null) {
          // fail to open new window
          this.showMessageBox()
        } else {
          // success and redirect to the url
          newWindow.location.href = url
        }

      } catch (error) {
        this.notify({ context: this, error })
      }
    },
    showMessageBox () {
      this.$alert('系統瀏覽器似乎阻擋了彈出式視窗，請先允許顯示視窗，並再次嘗試下載。', '請允許彈出式視窗', {
        confirmButtonText: '確定',
        showClose: false
      })
    }
  },
  computed: {
    ...mapGetters({
      table: 'download/table'
    })
  },
  mounted () {
    this.setTable()
  }
}
</script>
